var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"cyText",staticClass:"cy-text",style:(_vm.textStyle),on:{"mouseenter":_vm.mouseenter,"mouseleave":_vm.mouseleave}},[_vm._v(" "+_vm._s(_vm.value)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }